import React from 'react'

import Layout from '../../components/layout/layout'
import { menuItem } from '../../utils/helper'

const Home = () => {
  return (
    <Layout  menuItem = {menuItem}  >
        <span>  Welcome to Arcsine Analytics </span>
    </Layout>
  )
}

export default Home